import { Dispatch } from "redux";
import { getApiRequest } from "../../../../utils/tsUtils";
import { GET_SETTING_DATA, GET_SETTING_DATA_STATUS, GET_SETTING_USER_DATA, GET_SETTING_USER_DATA_STATUS } from "../constants";

export const getSettingAction = (query: any) => (dispatch: Dispatch) => {
  dispatch({ type: GET_SETTING_DATA_STATUS, payload: false });
  dispatch({ type: GET_SETTING_USER_DATA_STATUS, payload: false });
  getApiRequest(`get-user-calculator-setting/${query}`, null, dispatch, GET_SETTING_DATA);
};

export const getSettingUserData = () => (dispatch: Dispatch) => {
  dispatch({ type: GET_SETTING_USER_DATA_STATUS, payload: false });
  getApiRequest("setting-data", null, dispatch, GET_SETTING_USER_DATA);
};
